import "./styles/global.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import PaymentPortal from "./pages/PaymentPortal/PaymentPortal";
import ReportViewerMockPage from "./pages/ReportViewerMock/ReportViewerMockPage";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<PaymentPortal />} />
      <Route path="/report-viewer/mock" element={<ReportViewerMockPage />} />
    </Routes>
  );
};

export default App;
